module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-35.e89043a7.png";